import { createSlice } from "@reduxjs/toolkit";
import { getFromServerTopic } from "../utility/slice";
import { IDLE, SAVING } from "@src/constants.js";

const SLICE = "steamtraps";

const initialState = {
  status: IDLE,
  // Flag for the <BuildingStack /> to refresh the current data.
  updateCurrentSteamTrap: false,
};

export const getFromServer = (action, contextOptionsFn, payloadFn) =>
  getFromServerTopic({ topic: SLICE, action, contextOptionsFn, payloadFn });

export const getSteamTrapData = getFromServer(
  "getSteamTrapData",
  async ({ arg }) => arg,
  async (arg) => arg,
);

export const getSteamTrapsForSite = getFromServer(
  "getSteamTrapsForSite",
  async ({ arg }) => arg,
  async (arg) => arg,
);

export const saveSteamTrapAlerts = getFromServerTopic({
  topic: "alerts",
  action: "saveAlerts",
  contextOptionsFn: async ({ arg }) =>
    arg.map((it) => ({
      entityId: it.metrics[0].entityId,
      name: it.name,
    })),
  payloadFn: async (arg) => arg,
  clientCacheTtlSeconds: null,
});

export const bulkUpdateEquipmentMetadata = getFromServer(
  "bulkUpdateEquipmentMetadata",
  async ({ arg }) => arg.ids,
  async (arg) => arg,
);

export const slice = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    markCurrentSteamTrapForRefresh: (state) => {
      state.updateCurrentSteamTrap = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveSteamTrapAlerts.pending, (state) => {
        state.status = SAVING;
      })
      .addCase(saveSteamTrapAlerts.fulfilled, (state) => {
        state.status = IDLE;
        state.updateCurrentSteamTrap = false;
      })
      .addCase(getSteamTrapData.fulfilled, (state) => {
        state.updateCurrentSteamTrap = false;
      });
  },
});

export const INITIAL_STATE = slice.getInitialState();

export const { markCurrentSteamTrapForRefresh } = slice.actions;

export default slice.reducer;
